export default __webpack_public_path__ + "static/media/Victimizer9.e3221384.mp3";